module.exports = __webpack_public_path__ + "static/media/d2a.fe8edc55.png";